import React, { useEffect, useState } from 'react';
import { fetchCustomers } from '../lib/adminApi';
import { formatPrice } from '../../utils/formatPrice';

function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        const data = await fetchCustomers();
        if (!cancelled) setCustomers(data);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Could not load customers.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  const filtered = customers.filter(customer => {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    return (
      customer.name?.toLowerCase().includes(q) ||
      customer.email?.toLowerCase().includes(q)
    );
  });

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1 className="admin-page-title">Customers</h1>
        <p className="admin-page-subtitle">Customers derived from completed checkout activity</p>
      </div>

      <div className="admin-card">
        <div className="admin-toolbar">
          <input
            className="admin-search"
            placeholder="Search customers..."
            value={query}
            onChange={e => setQuery(e.target.value)}
          />
        </div>
        {error && <p className="admin-error">{error}</p>}
        {loading && <p className="admin-empty">Loading customers...</p>}
        {!loading && (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Orders</th>
                  <th>Total spent</th>
                  <th>Last order</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(customer => (
                  <tr key={customer.id}>
                    <td style={{ fontWeight: 600 }}>{customer.name}</td>
                    <td>{customer.email}</td>
                    <td>{customer.orders_count}</td>
                    <td>{formatPrice(customer.total_spent)}</td>
                    <td>{new Date(customer.last_order_at).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!filtered.length && <p className="admin-empty">No customers found.</p>}
          </div>
        )}
      </div>
    </div>
  );
}

export default Customers;
